import axios from "axios";
import setAuthToken from "./aut-headers"
import { jwtDecode } from 'jwt-decode' 
import JWTPayloadCRM from './crmjwt'
import {BASE_API_URL} from '../base_url'

const API_URL = BASE_API_URL + "/api/auth/";

class AuthService {
    
  login(username: string, password: string, remember:boolean) {
    return axios
      .post(API_URL + "login", {
        username,
        password,
        remember
      })
      .then(response => {
        if (response.data) {
          localStorage.setItem("crm_expo_token", JSON.stringify(response.data));
          setAuthToken(response.data.accessToken);
        }

        return response.data;
      });
  }

  logout() {
    localStorage.removeItem("crm_expo_token");
    
  }

  register(username: string, email: string, password: string) {
    return axios.post(API_URL + "register", {
      username,
      email,
      password
    });
  }

  getCurrentUser() {
    //return JSON.parse(localStorage.getItem('crm_expo_token'));

    var data = localStorage.getItem("crm_expo_token")
    if (data){
      var token = JSON.parse(data)
      if (token){ 
        var userData = (jwtDecode<JWTPayloadCRM>(token.accessToken))
        if (userData){
          return (userData)  
        }else{
          return null
        }
      }
      else{ 
        return null 
      }
    }
    return null

  }

 

  isAuth(){
    
    var data = localStorage.getItem("crm_expo_token")
    if (data){
      var token = JSON.parse(data)
      var date = new Date(token.accessTokenExpiration)
      if (token && (token.accessToken) && (token.accessTokenExpiration)){ // && (date.getTime() > Date.now())){
        var userData = jwtDecode(token.accessToken)
        if (userData && userData.exp && (userData.exp > Date.now() / 1000)){
          setAuthToken(token.accessToken);
          return true  
        }else{
          delete axios.defaults.headers.common["Authorization"]
          this.logout() 
          return false
        }
      }
      else{ 
        this.logout() 
        return false 
      }
    }
    this.logout() 
    return false
  }

  isAdmin(){
    var data = localStorage.getItem("crm_expo_token")
    if (data){
      var token = JSON.parse(data)
      var date = new Date(token.accessTokenExpiration)
      if (token && (token.accessToken) && (token.accessTokenExpiration)){ // && (date.getTime() > Date.now())){
        var userData = jwtDecode<JWTPayloadCRM>(token.accessToken)
        if (userData.group > 0 && (userData.group<=2)){
          return true  
        }else{
          return false
        }
      }
      else{ 
        this.logout() 
        return false 
      }
    }

    return false
  }

}

export default new AuthService();